import { render, staticRenderFns } from "./traning.vue?vue&type=template&id=6b51dd82&scoped=true"
import script from "./traning.vue?vue&type=script&lang=js"
export * from "./traning.vue?vue&type=script&lang=js"
import style0 from "./traning.vue?vue&type=style&index=0&id=6b51dd82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b51dd82",
  null
  
)

export default component.exports